import React, { useEffect, useState } from "react";

import Spinner from "../../../components/Spinner";

import style from "./style.module.css";

export default function Loader({ className = "" }) {

    const [winHeight, setWinHeight] = useState(0);
    useEffect(() => {
        const screenResize = () => {
            const header = document.querySelector('header');
            const headerHeight = header ? header.offsetHeight : 0;
            setWinHeight(window.innerHeight - headerHeight);
        };
        screenResize();
        window.addEventListener('resize', screenResize);
        return () => {
            window.removeEventListener('resize', screenResize);
        };
    }, []);

    return (
        <div className={`${style.loader}${style[className] ? ` ${style[className]}` : ``}`} style={{ minHeight: winHeight > 0 ? `${winHeight}px` : `80vh` }}>
            <div className={style.spinner}>
                <Spinner size="large" color='var(--spinner)' />
            </div>
        </div>
    )
}